import { Select } from "antd";

import {
  RadiusDimensions,
  XDA_PROJECTION_RADIUS_TYPES
} from "../hooks/useXdaProjectionOptions";

interface RadiusSelectorProps {
  value: string;
  onChange: (value: string) => void;
  jobRadiusOptions: Record<string, RadiusDimensions>;
}

export default function RadiusSelector({
  value,
  onChange,
  jobRadiusOptions
}: RadiusSelectorProps) {
  const jobNames = Object.keys(jobRadiusOptions);

  return (
    <div
      className="flex-column"
      style={{ gap: "3px", gridColumn: "1 / -1", marginBottom: "5px" }}>
      <span style={{ fontWeight: "bold" }}>Select Radius</span>
      <Select value={value} onChange={onChange} style={{ width: "100%" }}>
        <Select.Option value={XDA_PROJECTION_RADIUS_TYPES.Gross}>Gross</Select.Option>
        <Select.Option value={XDA_PROJECTION_RADIUS_TYPES.SweetSpot}>
          Sweet Spot
        </Select.Option>
        <Select.Option value={XDA_PROJECTION_RADIUS_TYPES.LandingZone}>
          Landing Zone
        </Select.Option>
        <Select.Option value={XDA_PROJECTION_RADIUS_TYPES.Custom}>Custom</Select.Option>

        {jobNames.length > 0 && (
          <Select.OptGroup label="Custom Calculation Radius">
            {jobNames.map((jobName) => (
              <Select.Option key={jobName} value={jobName}>
                {jobName}
              </Select.Option>
            ))}
          </Select.OptGroup>
        )}
      </Select>
    </div>
  );
}
